<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button v-if="!isEmployee"
                        variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Proyecto"
                        aria-label="Agregar Proyecto"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 200px; max-width: 260px;">
              <label class="filter-label">Clientes</label>
              <v-select :options="arr.select.customers" v-model="filters.customers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" v-if="!isEmployee" style="flex: 1 1 200px; max-width: 260px;">
              <label class="filter-label">Project Manager</label>
              <v-select :options="arr.select.employees" v-model="filters.employees" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 160px; max-width: 220px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.select.status" v-model="filters.status" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 170px;">
              <label class="filter-label">Fecha de Finalización</label>
              <b-form-datepicker v-model="filters.date_end"
                                  size="sm"
                                  placeholder="Todas"
                                  today-button
                                  reset-button
                                  close-button>
              </b-form-datepicker>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterProjects()" v-b-tooltip.hover title="Aplicar filtros"
                      style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card>
        <b-tabs class="crud-project-tabs" nav-class="crud-project-tabs__nav">

          <b-tab :active="tabs.with_expiration" @click="setActiveTab('with_expiration')">
            <template #title><AppIcon name="calendar" class="mr-1" />{{getNameTab('with_expiration')}}</template>

            <b-table class="app-table crud-project-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="true"
                    :items="tableWithExpiration.items"
                    :fields="tableWithExpiration.fields"
                    :tbody-tr-class="rowClass"
                    @row-clicked="onRowClicked"
                    v-if="tableWithExpiration.items.length">

                <template v-slot:table-colgroup="scope">
                    <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: isMobileViewport ? 'auto' : field.width }"
                    >
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(name)="data">
                  <div v-b-popover.hover.top="data.item.description" title="Descripción" v-if="data.item.description">
                    <AppIcon name="description" class="mr-1" style="font-size:17px;" />
                    {{ data.item.name }}
                  </div>
                  <div v-else>
                    {{ data.item.name }}
                  </div>
                </template>

                <template v-slot:cell(customer_id)="data">
                  <b-avatar :src="data.item.customer.image" size="25px" v-if="data.item.customer.image"></b-avatar>
                  <b-avatar v-else
                            size="25px"
                            :text="avatarFromName(data.item.customer.name).text"
                            :style="avatarFromName(data.item.customer.name).style">
                  </b-avatar>
                  &nbsp;<b>{{data.item.customer.name}}</b>
                  <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                </template>

                <template v-slot:cell(date_init)="data">
                  {{ moment(data.item.date_init).format('D/M/YYYY') }}
                </template>

                <template v-slot:cell(date_end)="data">
                  <div v-if="diffDate(data.item.date_end)==0" class="font-weight-bold text-warning">
                    {{ moment(data.item.date_end).format('D/M/YYYY') }}
                  </div>
                  <div v-if="diffDate(data.item.date_end)>0" class="font-weight-bold text-success">
                    {{ moment(data.item.date_end).format('D/M/YYYY') }}
                  </div>
                  <div v-if="diffDate(data.item.date_end)<0" class="font-weight-bold text-danger">
                    {{ moment(data.item.date_end).format('D/M/YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(employee_id)="data">
                  <div v-if="data.item.employee">
                    <b>{{ data.item.employee.id }} - {{ data.item.employee.name }}</b>
                  </div>
                  <div v-else>
                    <i>Sin Asignar</i>
                  </div>
                </template>

                <template v-slot:cell(hours_estimated)="data">
                  {{ data.item.hours_estimated }} Hs.
                </template>

                <template v-slot:cell(status)="data">
                  <b-badge variant="info" v-if="data.item.status=='active'">Activo</b-badge>
                  <b-badge variant="warning" v-if="data.item.status=='pause'">Pausado</b-badge>
                  <b-badge variant="success" v-if="data.item.status=='finished'">Finalizado</b-badge>
                  <b-badge variant="danger" v-if="data.item.status=='canceled'">Cancelado</b-badge>
                </template>

                <template v-slot:cell(equipo)="data">
                  <div v-if="data.item.equipo">
                    <b-badge  variant="secondary"
                              class="mr-1 badge-module-employee-custom"
                              v-for="value in filtroEmployee(data.item.equipo)"
                              :key="value.id"
                              v-b-tooltip.hover
                              :title="getNameEmployee(value)">
                      {{getInitialsNameEmployee(value)}}
                    </b-badge>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-project-action-toggle-labeled' : 'app-table-action-toggle'">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="openSub(data.item)">
                      <AppIcon name="visibility" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-item @click="irDetailHours(data.item)">
                      <AppIcon name="clock-history" /> Horas
                    </b-dropdown-item>
                    <b-dropdown-item @click="openNotes(data.item)">
                      <AppIcon name="sticky_note_2" /> Notas
                    </b-dropdown-item>
                    <b-dropdown-header v-if="!isEmployee">Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)" v-if="!isEmployee">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="!isEmployee">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else
                        icon="reports"
                        title="No se encontraron proyectos con vencimiento"
                        description="Ajustá los filtros para ampliar la búsqueda, o agregá un proyecto nuevo con el botón Agregar." />
          </b-tab>

          <b-tab :active="tabs.without_expiration" @click="setActiveTab('without_expiration')">
            <template #title><AppIcon name="all_inclusive" class="mr-1" />{{getNameTab('without_expiration')}}</template>

            <b-table class="app-table crud-project-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="true"
                    :items="tableWithoutExpiration.items"
                    :fields="tableWithoutExpiration.fields"
                    :tbody-tr-class="rowClass"
                    @row-clicked="onRowClicked"
                    v-if="tableWithoutExpiration.items.length">

                <template v-slot:table-colgroup="scope">
                    <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: isMobileViewport ? 'auto' : field.width }"
                    >
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(name)="data">
                  <div v-b-popover.hover.top="data.item.description" title="Descripción" v-if="data.item.description">
                    <AppIcon name="description" class="mr-1" style="font-size:17px;" />
                    {{ data.item.name }}
                  </div>
                  <div v-else>
                    {{ data.item.name }}
                  </div>
                </template>

                <template v-slot:cell(monthly_hours_included)="data">
                  <div v-if="data.item.monthly_hours_included">
                    <b>{{data.item.monthly_hours_included}} HS</b>
                  </div>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <span v-if="isMobileViewport">{{data.item.observations}}</span>
                    <span v-else v-b-tooltip.hover :title="data.item.observations"><AppIcon name="sticky_note_2" /></span>
                  </div>
                </template>

                <template v-slot:cell(customer_id)="data">
                  <b-avatar :src="data.item.customer.image" size="25px" v-if="data.item.customer.image"></b-avatar>
                  <b-avatar v-else
                            size="25px"
                            :text="avatarFromName(data.item.customer.name).text"
                            :style="avatarFromName(data.item.customer.name).style">
                  </b-avatar>
                  &nbsp;<b>{{data.item.customer.name}}</b>
                  <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                </template>

                <template v-slot:cell(date_init)="data">
                  {{ moment(data.item.date_init).format('D/M/YYYY') }}
                </template>

                <template v-slot:cell(employee_id)="data">
                  <div v-if="data.item.employee">
                    <b>{{ data.item.employee.id }} - {{ data.item.employee.name }}</b>
                  </div>
                  <div v-else>
                    <i>Sin Asignar</i>
                  </div>
                </template>

                <template v-slot:cell(status)="data">
                  <b-badge variant="info" v-if="data.item.status=='active'">Activo</b-badge>
                  <b-badge variant="warning" v-if="data.item.status=='pause'">Pausado</b-badge>
                  <b-badge variant="success" v-if="data.item.status=='finished'">Finalizado</b-badge>
                  <b-badge variant="danger" v-if="data.item.status=='canceled'">Cancelado</b-badge>
                </template>

                <template v-slot:cell(equipo)="data">
                  <div v-if="data.item.equipo">
                    <b-badge  variant="secondary"
                              class="mr-1 badge-module-employee-custom"
                              v-for="value in filtroEmployee(data.item.equipo)"
                              :key="value.id"
                              v-b-tooltip.hover
                              :title="getNameEmployee(value)">
                      {{getInitialsNameEmployee(value)}}
                    </b-badge>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-project-action-toggle-labeled' : 'app-table-action-toggle'">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="openSub(data.item)">
                      <AppIcon name="visibility" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-item @click="irDetailHours(data.item)">
                      <AppIcon name="clock-history" /> Horas
                    </b-dropdown-item>
                    <b-dropdown-item @click="openNotes(data.item)">
                      <AppIcon name="sticky_note_2" /> Notas
                    </b-dropdown-item>
                    <b-dropdown-header v-if="!isEmployee">Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)" v-if="!isEmployee">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="!isEmployee">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else
                        icon="reports"
                        title="No se encontraron proyectos sin vencimiento"
                        description="Ajustá los filtros para ampliar la búsqueda, o agregá un proyecto nuevo con el botón Agregar." />
          </b-tab>

        </b-tabs>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- DRAWER: detalle del proyecto seleccionado -->
      <b-sidebar id="sidebar-project-detail"
                v-model="detailDrawer"
                right
                shadow
                backdrop
                title="Detalle del Proyecto"
                width="420px"
                @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code">#{{itemSelected.id}}</span>
              <div>{{itemSelected.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.customer">{{itemSelected.customer.name}}</div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrev"
                        v-b-tooltip.hover
                        title="Proyecto anterior"
                        @click="goPrev()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNext"
                        v-b-tooltip.hover
                        title="Proyecto siguiente"
                        @click="goNext()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats" v-if="itemSelected.mode=='with_expiration'">
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Estimado</span>
              <span class="list-view-drawer__stat-value">{{itemSelected.hours_estimated}} Hs.</span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': sumTotalHours(arr.projectsHours) >= itemSelected.hours_estimated }">
              <span class="list-view-drawer__stat-label">Consumido</span>
              <span class="list-view-drawer__stat-value">{{sumTotalHours(arr.projectsHours)}} Hs.</span>
            </div>
          </div>
          <div class="list-view-drawer__stats" v-else>
            <div class="list-view-drawer__stat" v-if="itemSelected.monthly_hours_included">
              <span class="list-view-drawer__stat-label">Incluidas / Mes</span>
              <span class="list-view-drawer__stat-value">{{itemSelected.monthly_hours_included}} Hs.</span>
            </div>
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Consumido</span>
              <span class="list-view-drawer__stat-value">{{sumTotalHours(arr.projectsHours)}} Hs.</span>
            </div>
          </div>

          <div v-if="itemSelected.mode=='with_expiration'">
            <div v-if="itemSelected.status=='active'" v-html="diffDateHumanize(itemSelected.date_end)"/>
            <b-alert show variant="warning" v-if="itemSelected.status=='pause'"><AppIcon name="exclamation-triangle" class="mr-1" />El proyecto está pausado</b-alert>
            <b-alert show variant="danger" v-if="itemSelected.status=='canceled'"><AppIcon name="exclamation-triangle" class="mr-1" />El proyecto está cancelado</b-alert>
            <b-alert show variant="success" v-if="itemSelected.status=='finished'"><AppIcon name="info" class="mr-1" />El proyecto está finalizado</b-alert>
          </div>
          <div v-else>
            <b-alert show variant="info" v-if="itemSelected.status=='active'"><AppIcon name="info" class="mr-1" />El proyecto está activo</b-alert>
            <b-alert show variant="warning" v-if="itemSelected.status=='pause'"><AppIcon name="exclamation-triangle" class="mr-1" />El proyecto está pausado</b-alert>
            <b-alert show variant="danger" v-if="itemSelected.status=='canceled'"><AppIcon name="exclamation-triangle" class="mr-1" />El proyecto está cancelado</b-alert>
            <b-alert show variant="success" v-if="itemSelected.status=='finished'"><AppIcon name="info" class="mr-1" />El proyecto está finalizado</b-alert>
          </div>

          <b-row v-if="itemSelected.mode=='without_expiration'" class="mb-2">
            <b-col cols="5">
              <b-form-select size="sm" v-model="filters.months" :options="opt.months"></b-form-select>
            </b-col>
            <b-col cols="5">
              <b-form-select size="sm" v-model="filters.years" :options="opt.years"></b-form-select>
            </b-col>
            <b-col cols="2">
              <b-button size="sm" variant="outline-dark" @click="filterProjects()" v-b-tooltip.hover title="Aplicar">
                <AppIcon name="filter" />
              </b-button>
            </b-col>
          </b-row>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="people" /> Horas por empleado
            </div>
            <b-table-simple class="app-table app-table--compact app-table--stacked-manual" responsive small v-if="arr.projectsHours.length">
              <b-thead>
                <b-tr>
                  <b-th class="text-left">Empleado</b-th>
                  <b-th class="text-center">Horas</b-th>
                  <b-th class="text-right">Prom x Hora</b-th>
                  <b-th class="text-right">Total</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(item, index) in arr.projectsHours" :key="index">
                  <b-td data-label="Empleado" :class="'align-middle ' + alignClass('text-left')">{{item.data.name}}</b-td>
                  <b-td data-label="Horas" :class="'align-middle ' + alignClass('text-center')">{{sumTotalHoursByEmployee(item.group)}}</b-td>
                  <b-td data-label="Prom x Hora" :class="'align-middle ' + alignClass('text-right')">{{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format( costPromHoursEmployee(item.group) )}}</b-td>
                  <b-td data-label="Total" :class="'align-middle ' + alignClass('text-right')">{{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format( costTotalHoursEmployee(item.group) )}}</b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot>
                <b-tr>
                  <b-td colspan="4" variant="secondary" class="text-right">
                    Total horas: <b>{{ sumTotalHours(arr.projectsHours) }}</b>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td colspan="4" variant="secondary" class="text-right">
                    Promedio de horas: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(promTotalHours(arr.projectsHours))}}</b>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td colspan="4" variant="secondary" class="text-right">
                    Total costo: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(sumTotalCost(arr.projectsHours))}}</b>
                  </b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
            <EmptyState v-else icon="people" title="Sin horas cargadas" />
          </div>

          <div class="project-notes-preview">
            <div class="list-view-drawer__section-title">
              <span><AppIcon name="sticky_note_2" /> Notas</span>
              <b-button size="sm" variant="link" class="project-notes-preview__edit" @click="openNotes(itemSelected)">
                <AppIcon name="edit" /> Editar
              </b-button>
            </div>
            <div v-if="itemSelected.notes" class="project-notes-preview__content" v-html="itemSelected.notes"></div>
            <span v-else class="text-muted small">Sin notas cargadas.</span>
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="irDetailHours(itemSelected)">
              <AppIcon name="clock-history" class="mr-1" /> Horas
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="!isEmployee" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && !isEmployee">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <!-- CRUD MAIN: componente aparte (ProjectFormModal) con su propio
           render watcher — tipear en sus campos ya no fuerza el recálculo
           de las tablas grandes de este listado. Al editar, el propio
           componente busca el proyecto por su cuenta (no recibe el JSON
           ya cargado en la tabla). -->
      <ProjectFormModal :key="modal.form._id"
                        v-model="modal.form.active"
                        :project-id="modal.form.projectId"
                        @saved="onProjectSaved" />

      <b-modal v-model="modal.notes.active" size="xl" centered>
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="sticky_note_2" /></span>
          <h5 class="app-modal-header__title">Notas del proyecto</h5>
        </div>

        <div class="project-notes-context" v-if="modal.notes.project">
          <span v-if="modal.notes.project.customer" class="project-notes-context__customer">
            <b-avatar :src="modal.notes.project.customer.image" size="20px" v-if="modal.notes.project.customer.image" />
            <b-avatar v-else size="20px"
                      :text="avatarFromName(modal.notes.project.customer.name).text"
                      :style="avatarFromName(modal.notes.project.customer.name).style" />
            {{ modal.notes.project.customer.name }}
          </span>
          <div class="project-notes-context__project">
            <AppIcon name="folder" />
            <strong>{{ modal.notes.project.name }}</strong>
          </div>
        </div>

        <RichEditorImages v-if="modal.notes.project"
                          v-model="modal.notes.project.notes"
                          label="Notas importantes"
                          :with-gallery="false" />

        <template #modal-footer>
          <b-button variant="outline-secondary" @click="modal.notes.active = false">Cerrar</b-button>
          <b-button variant="dark" :disabled="!modal.notes.project || modal.notes.saving" @click="saveProjectNotes(modal.notes.project.notes)">
            <b-spinner v-if="modal.notes.saving" small class="mr-1" />
            <AppIcon v-else name="save" class="mr-1" />Guardar notas
          </b-button>
        </template>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import ProjectFormModal from './inc/ProjectFormModal'
  import RichEditorImages from '@/components/inc/editor/RichEditorImages'

  export default {
    components: {
      TabHeaderActions,
      ProjectFormModal,
      RichEditorImages
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudProject',
          elements: {}
        },
        filtersOpen: false,
        isMobileViewport: false,
        lastProjectSearch: '',
        detailDrawer: false,
        itemSelected: null,
        tableWithExpiration : {
          items: [],
          fields: [],
        },
        tableWithoutExpiration : {
          items: [],
          fields: [],
        },
        modal: {
          form: {
            active: false,
            projectId: 0,
            _id: '',
          },
          notes: {
            active: false,
            project: null,
            saving: false,
          },
        },
        arr: {
          employeeFilter: [],
          projectsWithExpiration: [],
          projectsWithoutExpiration: [],
          projectsHours: [],
          select:{
            employees:[],
            customers:[],
            status:[
              {code:'active', label: 'Activo'},
              {code:'pause', label: 'Pausado'},
              {code:'finished', label: 'Finalizado'},
              {code:'canceled', label: 'Cancelado'},
            ]
          }
        },
        filters: {
          customers: [],
          employees: [],
          status: [
            {code:'active', label: 'Activo'}
          ],
          date_end: '',
          months: '',
          years: '',
        },
        tabs: {
          with_expiration: true,
          without_expiration: false,
        },
        opt: {
          months: [],
          years: [],
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.filtersOpen = Storage.getValue('filters_open_crud_project') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()

      this.filterLoad()
      this.filterProjects()

      this.restoreStatusTabsStorage()
      this.openProjectFromRoute()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.filterLoad()
      this.filterProjects()
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_crud_project', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación de los fields tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
      '$route.query.project_search'() {
        this.openProjectFromRoute()
      },
    },
    computed: {
      isEmployee(){
        if(Helper.getEmployee()) {
          if(Helper.getEmployee().permission_admin_projects) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      },
      // El drawer puede navegar anterior/siguiente sin depender de cuál
      // pestaña está activa: el registro se busca dentro de la misma
      // tabla a la que pertenece (item.mode), no la que se ve en pantalla.
      activeItems() {
        if(!this.itemSelected) return []
        return this.itemSelected.mode == 'with_expiration' ? this.tableWithExpiration.items : this.tableWithoutExpiration.items
      },
      currentIndex() {
        if(!this.itemSelected) return -1
        return this.activeItems.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrev() {
        return this.currentIndex > 0
      },
      canGoNext() {
        if(this.currentIndex < 0) return false
        return this.currentIndex < (this.activeItems.length - 1)
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.tableWithExpiration.fields = []
        this.tableWithExpiration.fields.push({key: 'id', label: 'ID', sortable: true, class:"align-middle " + this.alignClass('text-center'), width:"3%"})
        this.tableWithExpiration.fields.push({key: 'customer_id', label: 'Cliente', sortable: true, class:"align-middle", width:"17%"})
        this.tableWithExpiration.fields.push({key: 'name', label: 'Nombre',class:"align-middle", width:"24%"})
        this.tableWithExpiration.fields.push({key: 'date_init', label: 'Inicio', class: "align-middle " + this.alignClass('text-center'), sortable: true, width:"6%"})
        this.tableWithExpiration.fields.push({key: 'date_end', label: 'Fin', class: "align-middle " + this.alignClass('text-center'), sortable: true, width:"6%"})
        this.tableWithExpiration.fields.push({key: 'hours_estimated', label: 'Estimación', class: "align-middle " + this.alignClass('text-center'), sortable: true, width:"6%"})
        this.tableWithExpiration.fields.push({key: 'employee_id', label: 'Project Manager', sortable: true, class:"align-middle", width:"15%"})
        this.tableWithExpiration.fields.push({key: 'equipo', label: 'Equipo', class:"align-middle", width:"15%"})
        this.tableWithExpiration.fields.push({key: 'status', label: 'Estado', class:"align-middle " + this.alignClass('text-center'), width:"5%"})
        // En mobile el kebab se conserva (a diferencia del default de
        // drawer), con label real de columna y texto "Opciones" visible.
        this.tableWithExpiration.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"3%"})

        this.tableWithoutExpiration.fields = []
        this.tableWithoutExpiration.fields.push({key: 'id', label: 'ID', sortable: true, class:"align-middle " + this.alignClass('text-center'), width:"3%"})
        this.tableWithoutExpiration.fields.push({key: 'customer_id', label: 'Cliente', sortable: true, class:"align-middle", width:"17%"})
        this.tableWithoutExpiration.fields.push({key: 'name', label: 'Nombre',class:"align-middle", width:"15%"})
        this.tableWithoutExpiration.fields.push({key: 'monthly_hours_included', label: 'HS Incluidas',class:"align-middle " + this.alignClass('text-center'), width:"10%"})
        this.tableWithoutExpiration.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"5%"})
        this.tableWithoutExpiration.fields.push({key: 'date_init', label: 'Inicio', class: "align-middle " + this.alignClass('text-center'), sortable: true, width:"7%"})
        this.tableWithoutExpiration.fields.push({key: 'employee_id', label: 'Project Manager', sortable: true, class:"align-middle", width:"15%"})
        this.tableWithoutExpiration.fields.push({key: 'equipo', label: 'Equipo', class:"align-middle", width:"20%"})
        this.tableWithoutExpiration.fields.push({key: 'status', label: 'Estado', class:"align-middle " + this.alignClass('text-center'), width:"5%"})
        // En mobile el kebab se conserva (a diferencia del default de
        // drawer), con label real de columna y texto "Opciones" visible.
        this.tableWithoutExpiration.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"3%"})
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      // Click en la fila abre el drawer de detalle, salvo que el click
      // haya sido sobre un control (el dropdown de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual al navegar con
      // anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // PROYECTO DETAIL (drawer)
      openSub(item) {
        this.itemSelected = item
        this.arr.projectsHours = Funciones.groupJSON(item.hours || [],'employee','id')
        this.detailDrawer = true
      },
      // Entrada desde la paleta: la lista puede estar filtrada (por ejemplo,
      // solo activos), así que se busca el proyecto por id para abrirlo igual
      // y luego se selecciona la pestaña que corresponde a su modo.
      openProjectFromRoute() {
        var query = this.$route.query || {}
        var projectId = Number(query.project_id)
        var requestKey = query.project_search || String(projectId || '')
        if(!projectId || !requestKey || requestKey === this.lastProjectSearch) return

        this.lastProjectSearch = requestKey
        serviceAPI.mostrarProyectos(projectId)
          .then(response => {
            var project = response.data
            if(!project) return
            this.setActiveTab(project.mode)
            this.openSub(project)
          })
          .catch(error => this.$awn.alert(ErrorToken.valid(error)))
      },
      hideSub() {
        this.itemSelected = null
        this.arr.projectsHours = []
        this.detailDrawer = false
        this.clearProjectRouteContext()
      },
      // El destino de Ctrl+K es transitorio. Al cerrar el sidebar se limpia
      // para volver a una pantalla de proyectos normal y evitar que el
      // registro se abra otra vez al recargar o reactivar la pestaña.
      clearProjectRouteContext() {
        var query = Object.assign({}, this.$route.query || {})
        if(!query.project_id && !query.project_search) return

        delete query.project_id
        delete query.project_search
        this.$router.replace({ query: query }).catch(() => {})
      },
      // Anterior/siguiente reusa openSub() con el vecino de la misma
      // tabla (item.mode), así el contenido y el resaltado de fila se
      // actualizan por el mismo camino que un click directo.
      goPrev() {
        if(!this.canGoPrev) return
        this.openSub(this.activeItems[this.currentIndex - 1])
      },
      goNext() {
        if(!this.canGoNext) return
        this.openSub(this.activeItems[this.currentIndex + 1])
      },
      add() {
        this.modal.form.projectId = 0
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
      },
      edit(item) {
        this.modal.form.projectId = item.id
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
      },
      openNotes(item) {
        this.modal.notes.project = item
        this.modal.notes.active = true
      },
      saveProjectNotes(notes) {
        if(!this.modal.notes.project) return

        this.modal.notes.saving = true
        serviceAPI.guardarNotasProyecto(this.modal.notes.project.id, notes)
          .then(response => {
            this.modal.notes.project.notes = response.data.notes
            this.$awn.success('Notas guardadas con éxito')
          })
          .catch(error => this.$awn.alert(Error.showError(error)))
          .finally(() => { this.modal.notes.saving = false })
      },
      // Confirm estándar: header con ícono + tinte suave
      // (.app-confirm-header) en vez de header-bg-variant sólido, size
      // 'sm' siempre, y okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      remove(item) {
        this.confirmDialog('¿Desea borrar el proyecto (' + item.id + ') - '+ item.name + '?', {
          title: 'Borrar Proyecto',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarProyectos(item.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()

              // Si el proyecto eliminado es el que está abierto en el
              // drawer, cerrarlo — si no, queda mostrando un registro ya
              // borrado con sus botones (Editar/Eliminar) todavía activos.
              if(this.itemSelected && this.itemSelected.id === item.id) {
                this.hideSub()
              }

              this.filterProjects()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      // El propio ProjectFormModal ya hizo la llamada a la API y mostró el
      // toast de éxito — acá solo hay que refrescar el listado (y el
      // drawer, si sigue abierto sobre el registro recién guardado).
      onProjectSaved() {
        this.filterProjects(!!this.itemSelected)
      },
      loadArrEmployeeFilter() {
        var result = serviceAPI.obtenerEmpleado()
        result.then((response) => {
          var data = response.data
          this.arr.employeeFilter = data
        })
      },
      filtroEmployee(row) {
        var arr = []
        row.split(',').forEach(element => {
          arr.push(element)
        })

        var arrActive = []
        if(arr) {
          arr.forEach(element => {
            this.arr.employeeFilter.forEach(element1 => {

              if(element1.active) {
                if(parseInt(element)==element1.id) {
                  arrActive.push(element)
                }
              }
            })

          });
        }

        return arrActive
      },
      getNameEmployee(value) {
        var val = ''
        this.arr.employeeFilter.forEach(element => {
          if(parseInt(value)==element.id) {
            val = element.name
          }
        })
        return val
      },
      getInitialsNameEmployee(value) {
        var val = ''
        this.arr.employeeFilter.forEach(element => {
          if(parseInt(value)==element.id) {
            val = element.name
          }
        })

        var fullName = val.split(' ')
        var initialsName = ''
        fullName.forEach(element => {
          initialsName = initialsName + element.charAt(0)
        });

        if(!initialsName) {
          initialsName = val
        }
        return initialsName
      },
      sumTotalHoursByEmployee(arr) {
        var sum = 0
        arr.forEach(element => {
          sum = sum + parseFloat(element.hours)
        });
        return sum
      },
      costPromHoursEmployee(arr) {
        var sum = 0
        var cant = arr.length

        arr.forEach(element => {
          sum = sum + parseFloat(element.price)
        });
        return sum / cant
      },
      costTotalHoursEmployee(arr) {
        var sum = 0

        arr.forEach(element => {
          sum = sum + parseFloat(element.price_total)
        });
        return sum
      },
      sumTotalHours(arr) {
        var sum = 0
        arr.forEach(element => {
          element.group.forEach(element1 => {
            sum = sum + parseFloat(element1.hours)
          });
        });
        return sum
      },
      sumTotalCost(arr) {
        var sum = 0
        arr.forEach(element => {
          element.group.forEach(element1 => {
            sum = sum + parseFloat(element1.price_total)
          });
        });
        return sum
      },
      promTotalHours(arr) {
        var totalHours = this.sumTotalHours(arr)
        var totalCost = this.sumTotalCost(arr)

        if(totalHours) {
          return totalCost / totalHours
        } else {
          return 0
        }
      },
      diffDateHumanize(date){
        var dias = this.diffDate(date)

        if(dias == 0) {
          return '<div class="alert alert-warning"><b>El proyecto vence hoy</b></div>'
        }
        if(dias>0) {
          return '<div class="alert alert-success"><b>El proyecto vence ' + moment.duration(dias,'days').humanize(true) + "</b></div>"
        } else {
          return '<div class="alert alert-danger"><b>El proyecto venció ' + moment.duration(dias,'days').humanize(true) + "</b></div>"
        }
      },
      diffDate(date){
        var vto = moment(date, "YYYY-MM-DD");
        var hoy = moment().startOf('day');
        var dias = moment.duration(vto.diff(hoy)).asDays()

        return dias
      },
      porcentajeHorasRestantes(val1, val2) {
        if(val2>0) {
          return (val1/val2)*100
        } else {
          return 0
        }

      },
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadEmployees()
        this.setFilterEmployeesPermission()
        this.filterMonthsYears()

        this.restoreFilterStorage()
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()
        result.then((response) => {
          var data = response.data

          this.arr.select.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.select.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.select.customers.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterLoadEmployees() {
        var result = serviceAPI.obtenerEmpleado()
        result.then((response) => {
          var data = response.data

          this.arr.select.employees = []
          data.forEach(element => {
            this.arr.select.employees.push({ code: element.id, label: element.name })
          });
        })
      },
      // El segundo parámetro (forceOpenSub) refresca el drawer si sigue
      // abierto sobre un registro que acaba de cambiar (alta/edición) —
      // sin esto, el drawer queda mostrando datos viejos aunque la tabla
      // de atrás ya esté actualizada.
      filterProjects(forceOpenSub=false){
        this.saveFilterStorage()

        let loader = this.$loading.show();

        this.tableWithExpiration.items = []
        this.arr.projectsWithExpiration = []
        this.tableWithoutExpiration.items = []
        this.arr.projectsWithoutExpiration = []

        var result = serviceAPI.filtrarProyectos(this.filters)
        result.then((response) => {
          var data = response.data

          data.forEach(element => {
            if(element.mode == 'with_expiration') {
              this.tableWithExpiration.items.push(element)
              this.arr.projectsWithExpiration.push(element)
            }

            if(element.mode == 'without_expiration') {
              this.tableWithoutExpiration.items.push(element)
              this.arr.projectsWithoutExpiration.push(element)
            }
          });

          if(forceOpenSub && this.itemSelected) {
            var found = this.tableWithExpiration.items.find(i => i.id === this.itemSelected.id) ||
                        this.tableWithoutExpiration.items.find(i => i.id === this.itemSelected.id)

            if(found) {
              this.openSub(found)
            } else {
              this.hideSub()
            }
          }

          this.loadArrEmployeeFilter()
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(ErrorToken.valid(error));
        })
      },
      filterMonthsYears() {
        // prepare months
          this.opt.months.push({value:'01', text:'Enero'})
          this.opt.months.push({value:'02', text:'Febrero'})
          this.opt.months.push({value:'03', text:'Marzo'})
          this.opt.months.push({value:'04', text:'Abril'})
          this.opt.months.push({value:'05', text:'Mayo'})
          this.opt.months.push({value:'06', text:'Junio'})
          this.opt.months.push({value:'07', text:'Julio'})
          this.opt.months.push({value:'08', text:'Agosto'})
          this.opt.months.push({value:'09', text:'Septiembre'})
          this.opt.months.push({value:'10', text:'Octubre'})
          this.opt.months.push({value:'11', text:'Noviembre'})
          this.opt.months.push({value:'12', text:'Diciembre'})
        // fin

        // prepare yeras
          var yearNow = moment().format('YYYY')
          var yearLimit = 2015

          for (let index = yearLimit; index <= yearNow; index++) {
            this.opt.years.push({
              value: index,
              text: index,
            })
          }
          this.opt.years = this.opt.years.reverse()
        // fin
      },
      setFilterEmployeesPermission() {
        if(this.isEmployee) {
          var reg = Helper.getEmployee()
          this.filters.employees.push(
            {label: reg.name, code: reg.id}
          )
        }
      },
      irDetailHours(data) {
        this.$router.push({ name: 'ProjectStaffDetailHoursProjects', params: { projectID: data.id } })
      },

      //TABS
      disableAllTabs() {
        this.tabs.with_expiration = false
        this.tabs.without_expiration = false
      },
      setActiveTab(value) {
        this.disableAllTabs()

        switch (value) {
          case 'with_expiration':
            this.tabs.with_expiration = true
            break;

          case 'without_expiration':
            this.filters.months = moment().format('MM')
            this.filters.years = moment().format('YYYY')
            this.filterProjects()
            this.tabs.without_expiration = true
            break;

          default:
            this.tabs.with_expiration = true
            break;
        }

        this.saveStatusTabsStorage()
      },
      getNameTab(name) {
        if(name == 'with_expiration') {
          let cant = this.tableWithExpiration.items.length
          if(cant) {
            return 'Proyectos con Vencimiento (' + cant + ')'
          } else {
            return 'Proyectos con Vencimiento'
          }
        }

        if(name == 'without_expiration') {
          let cant = this.tableWithoutExpiration.items.length
          if(cant) {
            return 'Proyectos sin Vencimiento (' + cant + ')'
          } else {
            return 'Proyectos sin Vencimiento'
          }
        }
      },

      // TABS SAVE
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_projects', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_projects')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_projects'))
        }

        this.filters.months = moment().format('MM')
        this.filters.years = moment().format('YYYY')
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_view_projects', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_view_projects')) {
          this.filters = JSON.parse(Storage.getValue('filter_view_projects'))
        }
      },
    }
  }
</script>
<style scoped>
  .badge-module-employee-custom {
    font-size: 14px;
    color: var(--app-color-text-secondary);
    background-color: transparent;
    border-color: var(--app-color-border);
    border-style: solid;
    border-width: 0.5px;
  }

  .project-notes-context {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin: 0 0 14px;
    color: var(--app-color-text-secondary);
    font-size: 13px;
  }
  .project-notes-context__customer {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--app-color-text-muted);
    font-size: 12px;
    font-weight: 500;
  }
  .project-notes-context__project {
    display: flex;
    align-items: center;
    gap: 7px;
    color: var(--app-color-text);
  }
  .project-notes-context__project .app-icon {
    color: var(--app-color-primary);
  }
  .project-notes-context__project strong {
    font-size: 18px;
    line-height: 1.25;
  }
  .project-notes-preview {
    margin-top: 20px;
  }
  .project-notes-preview .list-view-drawer__section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .project-notes-preview__edit {
    padding: 0;
    color: var(--app-color-primary);
    font-size: 12px;
  }
  .project-notes-preview__content {
    max-height: 260px;
    overflow: auto;
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    color: var(--app-color-text);
    font-size: 13px;
    line-height: 1.5;
  }
  .project-notes-preview__content ::v-deep img {
    max-width: 100%;
    height: auto;
  }
  .project-notes-preview__content ::v-deep p:last-child {
    margin-bottom: 0;
  }
  @media (max-width: 575.98px) {
    .project-notes-context {
      flex-wrap: wrap;
    }
  }

  /* Excepción al kebab mudo de .app-table: esta tabla conserva el
     dropdown de acciones también en mobile (no depende solo del drawer),
     como link de texto alineado a la izquierda, no como botón con caja. */
  .btn.crud-project-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-project-action-toggle-labeled:hover,
  .btn.crud-project-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  /* Pisa la regla global que oculta el label del último field y lo
     alinea a la derecha (pensada para el kebab ícono-only sin texto) —
     acá sí se muestra "Acción" y el control queda a la izquierda, en
     línea con el resto de los valores apilados. */
  @media (max-width: 767.98px) {
    .crud-project-tabs ::v-deep .crud-project-tabs__nav {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0 2px 9px;
      border-bottom: 0;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      white-space: nowrap;
    }
    .crud-project-tabs ::v-deep .crud-project-tabs__nav::-webkit-scrollbar {
      display: none;
    }
    .crud-project-tabs ::v-deep .crud-project-tabs__nav > .nav-item {
      flex: 0 0 auto;
    }
    .crud-project-tabs ::v-deep .crud-project-tabs__nav .nav-link {
      display: inline-flex;
      align-items: center;
      padding: 6px 14px;
      border-radius: 20px;
      color: var(--app-color-text-secondary);
      background: transparent;
      font-weight: var(--app-font-medium);
      transition: background-color 0.15s ease, color 0.15s ease;
    }
    .crud-project-tabs ::v-deep .crud-project-tabs__nav .nav-link:hover:not(.active) {
      color: var(--app-color-primary);
      background: var(--app-color-primary-soft);
    }
    .crud-project-tabs ::v-deep .crud-project-tabs__nav .nav-link.active,
    .crud-project-tabs ::v-deep .crud-project-tabs__nav > .nav-item.active > .nav-link {
      background: var(--app-color-primary);
      color: var(--app-color-on-primary) !important;
      box-shadow: var(--app-shadow-sm);
    }
    .crud-project-tabs ::v-deep .nav-link .app-icon {
      margin-right: 5px !important;
    }
    .crud-project-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-project-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
